import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/philosopher/400.css";
import "@fontsource/philosopher/700.css";

export const inter = {
  className: "font-inter",
};

export const philosopher = {
  className: "font-philosopher",
};
